import apiRequestService from '@/commonProject/service/apiRequestService';

export default class MonthlyReportRepository {
    /**
     * 月次レポート期間取得API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportPeriodApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerGet(API_URL + '/monreppri', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート表示可否確認API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportCheckApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepchk', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（利用者）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportCliantApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepcli', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（利用実績1）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportConfigApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepcng', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（利用実績2）API
     * グルーピングを行う。
     * データの結果が15人以下の場合は負の値が入る。
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportUseApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepuse', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（利用実績イシュー分類別）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportIssueClassApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepcngisucat', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（利用実績イシュー別）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportIssueApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepcngisu', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（リファー先）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportReferApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepref', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（現況把握回答）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportUnderstandApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepcsa', requestBody, idToken);
        return result;
    }
    /**
     * 月次レポート（アンケート回答）API
     * @param {String} API_URL
     * @param {Object} requestBody
     * @returns result
     */
    async getMonthlyReportQuestionApi(API_URL, requestBody, idToken) {
        const result = await apiRequestService.requestServerPost(API_URL + '/monrepque', requestBody, idToken);
        return result;
    }
}
